import template from './historyEntryList.html';
import { HistoryEntryListController } from './historyEntryList.controller';

export const historyEntryListComponent = {
  name: 'historyComponent',
  restrict: 'E',
  template,
  controllerAs: 'vm',
  controller: HistoryEntryListController,
  bindings: {
    events: '<',
    onClick: '&',
  },
};
